var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisibility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 81,
    viewBox: "0 0 80 81",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M46.1629 35.0946C46.1629 40.8027 41.4222 45.4153 35.5555 45.4153C29.6889 45.4153 24.9481 40.8027 24.9481 35.0946C24.9481 29.3865 29.6889 24.7739 35.5555 24.7739C41.4222 24.7739 46.1629 29.3865 46.1629 35.0946Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M35.5556 58.936C46.0148 58.936 55.763 52.9396 62.5482 42.5612C65.2148 38.4964 65.2148 31.6639 62.5482 27.5991C55.763 17.2207 46.0148 11.2243 35.5556 11.2243C25.0963 11.2243 15.3482 17.2207 8.56299 27.5991C5.89632 31.6639 5.89632 38.4964 8.56299 42.5612C15.3482 52.9396 25.0963 58.936 35.5556 58.936Z",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8222 56.7378C41.6444 56.154 40.3333 55.8513 39 55.8513C28.6 56.5648 28.6 71.2892 39 72.0027H63.6444C66.6444 72.0243 69.5333 70.9432 71.7333 68.9757C79.0444 62.7702 75.1333 50.2946 65.5111 49.1054C62.0444 28.8459 31.9777 36.5432 39.1111 55.8513",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M42.8222 56.7378C41.6444 56.154 40.3333 55.8513 39 55.8513C28.6 56.5648 28.6 71.2892 39 72.0027H63.6444C66.6444 72.0243 69.5333 70.9432 71.7333 68.9757C79.0444 62.7702 75.1333 50.2946 65.5111 49.1054C62.0444 28.8459 31.9777 36.5432 39.1111 55.8513",
    stroke: "#C499F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8888 50.0567C63.0444 49.4946 64.311 49.1918 65.5999 49.1702L61.8888 50.0567Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M61.8888 50.0567C63.0444 49.4946 64.311 49.1918 65.5999 49.1702",
    stroke: "#C499F3",
    strokeWidth: 4,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisibility);
export default __webpack_public_path__ + "static/media/visibility.119c42ce5b0b553fc1c6c0c13e7ffbfb.svg";
export { ForwardRef as ReactComponent };